import { keyframes } from "@emotion/react";
import { min, transform } from "lodash";

export default function themeOverrides(theme) {

  const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
  return {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: theme.colors.white,
          boxShadow: "none",
          padding: "0px 0px",
        },
      },
    },
    MuiInputBase: {
  styleOverrides: {
    root: {
      borderRadius: ".3rem",
      backgroundColor: theme.colors.white,
      color: theme.colors.bodyText,
      "&.MuiOutlinedInput-root": {
        padding: "0px",
      },
      "& .MuiInputBase-input": {
        padding: ".45rem .77rem!important",
        fontSize: ".87rem",
        height: "auto",
        color: theme.colors.bodyText,
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.colors.themeBorder,
        padding: "0px",
        borderWidth: "1px!important",
      },
      "&.Mui-focused,&.Mui-error,&:hover,&:focus": {
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: theme.colors.primaryMain + "!important", // Changed to primary color on hover/focus
          borderWidth: "1px!important", // Optional: make border thicker on hover

        },
      },

      "&.Mui-disabled": {
        backgroundColor: "#f5f5f5",
        cursor: "not-allowed",
        "& .MuiInputBase-input": {
          color: "rgba(0, 0, 0, 0.30)",
          WebkitTextFillColor: "rgba(0, 0, 0, 0.30)",
          cursor: "not-allowed",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "rgba(0, 0, 0, 0.12)!important",
        },
        "&:hover": {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(0, 0, 0, 0.12)!important",
          },
        },
      },
    },
  },
},
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: "0px",
          marginRight: "0px",
          color: theme.colors.error + "!important",
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          "&.rotating": {
            animation: `${spin} 10s linear infinite`,
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          "& .MuiInputBase-root": {
            padding: "0px!important",
            // '&.Mui-disabled': {
            //   backgroundColor: '#f5f5f5',
            //   '& .MuiOutlinedInput-notchedOutline': {
            //     borderColor: 'rgba(0, 0, 0, 0.12)',
            //   },
            // },
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontSize: "0.87rem",
          color: theme.colors.bodyText,
          marginBottom: "0.5rem",
          transform: "translate(0px, 0px) scale(1)!important",
          "&.Mui-disabled": {
            color: theme.colors.bodyText,
          },
          "&.Mui-error": {
            color: theme.colors.bodyText,
          },
        },
      },
    },
    // MuiFormControl:{
    //   styleOverrides:{
    //     root:{
    //      minHeight:'62px',
    //     }
    //   }
    // },
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          borderRadius: "0.3rem",
          padding: "0.4rem 0.8rem",
          fontSize: "0.87rem",
          fontWeight: "normal",
          textTransform: "capitalize",
          border: "1px solid transparent",
          "&:hover, &:focus": {
            boxShadow: "none",
          },
          "&.MuiButton-containedPrimary": {
            backgroundColor: theme.colors.primary,
            color: theme.colors.white,
            "&:hover, &:focus": {
              backgroundColor: theme.colors.white,
              borderColor: theme.colors.primary,
              color: theme.colors.primary,
            },
          },
          "&.MuiButton-outlinedPrimary": {
            backgroundColor: theme.colors.white,
            color: theme.colors.primary,
            border: `1px solid ${theme.colors.primary}`,
            "&:hover, &:focus": {
              backgroundColor: theme.colors.primary,
              borderColor: theme.colors.primary,
              color: theme.colors.white,
            },
          },
          "&.MuiButton-containedDefault": {
            backgroundColor: theme.colors.light,
            color: theme.colors.dark,
            "&:hover, &:focus": {
              backgroundColor: theme.colors.white,
              borderColor: theme.colors.light,
              color: theme.colors.dark,
            },
          },
          "&.Mui-disabled": {
            backgroundColor: theme.colors.disabledBackground || "#e0e0e0",
            color: theme.colors.disabledText || "#9e9e9e",
            borderColor: "transparent",
            cursor: "not-allowed",
            opacity: 0.6,
          },
          "&.MuiButton-outlinedDefault": {
            backgroundColor: theme.colors.white,
            color: theme.colors.dark,
            border: `1px solid ${theme.colors.light}`,
            "&:hover, &:focus": {
              backgroundColor: theme.colors.light,
              borderColor: theme.colors.light,
              color: theme.colors.dark,
            },
          },
        },
      },
    },
    // MuiIconButton:{
    //   styleOverrides: {
    //     root: {
    //       boxShadow:'none',
    //       borderRadius:'0.3rem',
    //       padding:'0.4rem 0.8rem',
    //       fontSize:'0.9rem',
    //       fontWeight:'normal',
    //       textTransform:'capitalize',
    //       color:theme.colors.primary,
    //       border:'1px solid #ced4da',
    //       '&:hover, &:focus':{
    //         boxShadow:'none',
    //       },
    //     }
    //   }
    // },
    MuiChip: {
      styleOverrides: {
        root: {
          height: "auto",
          fontSize: "0.8rem",
          "& .MuiSvgIcon-root": {
            fontSize: "1rem",
          },
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          paddingLeft: "0px!important",
          paddingRight: "0px!important",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          marginBottom: "1.5rem",
          border: "none",
          borderRadius: "0.3rem",
          overflow: "inherit",
          boxShadow:"none",
          "&:last-child": {
            marginBottom: "0px",
          },
          "&.report-card": {
            borderRadius: "0.3rem",
            "& .MuiCardHeader-root": {
              padding: "0.75rem",
              "& .MuiCardHeader-title": {
                fontSize: "0.875rem",
                fontWeight: "500",
                textTransform: "uppercase",
              },
            },
            "& .MuiCardContent-root": {
              padding: "0.875rem",
              "& .MuiTypography-root": {
                fontSize: "1.30rem",
              },
            },
            "& .MuiList-root": {
              padding: "0px",
              "& .MuiListItem-root": {
                padding: "0.5rem 0.5rem",
                justifyContent: "space-between",
                borderBottom: `1px solid ${theme.colors.themeBorder}`,
                "&:last-child": {
                  borderBottom: "none",
                },
                "& .MuiTypography-root": {
                  fontSize: "0.875rem!important",
                  cursor: "pointer",
                },
                "&:hover": {
                  backgroundColor: theme.colors.lightPrimary,
                },
              },
            },
          },
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: "1.5rem",
          "&:last-child": {
            paddingBottom: "1.5rem",
          },
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          padding: "1.1rem 1.5rem",
          "& .MuiCardHeader-title": {
            fontSize: "1.15rem",
            fontWeight: "600",
          },
          "& .MuiCardHeader-action": {
            margin: "0px",
          },
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          "&.main-sidebar": {
            padding: "0px",
            maxHeight: "calc(100vh - 65px)",
            overflowY: "auto",
            "& .MuiListItem-root": {
              "& .MuiListItemButton-root": {
                padding: ".75rem 1rem",
                "&:hover": {
                  backgroundColor: theme.colors.lightPrimary,
                  "& .MuiListItemText-root": {
                    "& .MuiTypography-root": {
                      color: theme.colors.primary,
                    },
                  },
                  "& .actionIcon": {
                    "&.actionIcon-favorites": {
                      opacity: 1,
                    },
                    "& .remixicon": {
                      fill: theme.colors.primary,
                    },
                  },
                },
                "& .MuiListItemIcon-root": {
                  minWidth: "18px",
                  marginRight: "0.60rem",
                  "& .remixicon": {
                    width: "1.25rem",
                    height: "1.25rem",
                    color: theme.colors.primary,
                  },
                },
                "& .MuiListItemText-root": {
                  margin: "0px",
                  "& .MuiTypography-root": {
                    fontSize: "0.875rem",
                    color: "#6c757d",
                  },
                },
                "& .actionIcon": {
                  position: "absolute",
                  right: "0.50rem",
                  top: "50%",
                  transform: "translateY(-50%)",
                  marginRight: "0rem",
                  "&.actionIcon-favorites": {
                    opacity: 0,
                  },
                  "& .remixicon": {
                    fill: "#6c757d",
                    width: "1.50rem",
                    height: "1.50rem",
                  },
                },
              },
            },
            "& .MuiCollapse-root": {
              "& .MuiList-root": {
                // paddingLeft: '2.50rem',
                "& .MuiListItemButton-root": {
                  padding: ".45rem 1rem",
                  margin: "4px 0px",
                  "&:hover": {
                    backgroundColor: "transparent",
                    "& .MuiListItemText-root": {
                      "& ::before": {
                        borderColor: theme.colors.primary,
                      },
                      "& .MuiTypography-root": {
                        color: theme.colors.primary,
                      },
                    },
                    "& .actionIcon": {
                      "&.actionIcon-favorites": {
                        opacity: 1,
                      },
                      "& .remixicon": {
                        fill: theme.colors.primary,
                      },
                    },
                  },
                  "& .MuiListItemText-root": {
                    margin: "0px",
                    position: "relative",
                    marginLeft: "10px",
                    "& ::before": {
                      content: '""',
                      position: "absolute",
                      left: "-1rem",
                      top: "50%",
                      transform: "translateY(-50%)",
                      width: "5px",
                      height: "5px",
                      backgroundColor: "transparent",
                      borderRadius: "50%",
                      border: "1px solid #6c757d",
                    },
                    "& .MuiTypography-root": {
                      fontSize: ".87rem",
                      color: "#6c757d",
                    },
                  },
                  "& .actionIcon": {
                    position: "absolute",
                    right: "1rem",
                    top: "50%",
                    transform: "translateY(-50%)",
                    minWidth: "auto",
                    "&.actionIcon-favorites": {
                      opacity: 0,
                    },
                    "& .remixicon": {
                      fill: "#6c757d",
                      width: "1.50rem",
                      height: "1.50rem",
                    },
                  },
                },
              },
              "& .MuiCollapse-root": {
                "& .MuiList-root": {
                  paddingLeft: "1rem",
                },
              },
            },
          },
          "&.popover-sidebar-list": {
            backgroundColor: "#eeeef3",
            padding: "0px",
            "& .MuiListItem-root": {
              padding: ".75rem 1rem",
              backgroundColor: theme.colors.primary,
              "& .MuiListItemText-root": {
                "& .MuiTypography-root": {
                  color: theme.colors.white,
                  fontSize: "0.875rem",
                  fontWeight: "600",
                },
              },
            },
            "& .MuiListItemButton-root": {
              padding: ".75rem 1rem",
              position: "relative",
              "&:hover": {
                backgroundColor: theme.colors.lightPrimary,
                "& .actionIcon": {
                  "&.actionIcon-favorites": {
                    opacity: 1,
                  },
                  "& .remixicon": {
                    fill: theme.colors.primary,
                  },
                },
              },
              "& .MuiListItemText-root": {
                fontSize: "0.87rem",
                color: theme.colors.bodyText,
                margin: "0px",
              },
              "& .MuiListItemIcon-root": {
                minWidth: "18px",
                marginRight: "0",
                "& .remixicon": {
                  width: "1.25rem",
                  height: "1.25rem",
                },
              },
              "& .actionIcon": {
                position: "absolute",
                right: "1rem",
                top: "50%",
                transform: "translateY(-50%)",
                minWidth: "auto",
                "&.actionIcon-favorites": {
                  opacity: 0,
                  transition: "opacity 0.2s ease-in-out",
                },
                "& .remixicon": {
                  fill: "#6c757d",
                  width: "1.50rem",
                  height: "1.50rem",
                },
              },
            },
            "& .MuiCollapse-root": {
              "& .MuiList-root": {
                paddingLeft: "2.50rem",
                "& .MuiListItemButton-root": {
                  padding: ".45rem 1rem",
                  margin: "4px 0px",
                  "&:hover": {
                    backgroundColor: "transparent",
                    "& .MuiListItemText-root": {
                      "& ::before": {
                        borderColor: theme.colors.primary,
                      },
                      "& .MuiTypography-root": {
                        color: theme.colors.primary,
                      },
                    },
                    "& .actionIcon": {
                      "&.actionIcon-favorites": {
                        opacity: 1,
                      },
                      "& .remixicon": {
                        fill: theme.colors.primary,
                      },
                    },
                  },
                  "& .MuiListItemText-root": {
                    margin: "0px",
                    position: "relative",
                    "& ::before": {
                      content: '""',
                      position: "absolute",
                      left: "-1rem",
                      top: "50%",
                      transform: "translateY(-50%)",
                      width: "5px",
                      height: "5px",
                      backgroundColor: "transparent",
                      borderRadius: "50%",
                      border: "1px solid #6c757d",
                    },
                    "& .MuiTypography-root": {
                      fontSize: ".85rem",
                      color: "#6c757d",
                    },
                  },
                  "& .actionIcon": {
                    position: "absolute",
                    right: "1rem",
                    top: "50%",
                    transform: "translateY(-50%)",
                    minWidth: "auto",
                    "&.actionIcon-favorites": {
                      opacity: 0,
                    },
                    "& .remixicon": {
                      fill: "#6c757d",
                      width: "1.50rem",
                      height: "1.50rem",
                    },
                  },
                },
              },
              "& .MuiCollapse-root": {
                "& .MuiList-root": {
                  paddingLeft: "1rem",
                },
              },
            },
          },
        },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          borderCollapse: "separate",
          borderSpacing: "0px",
          "& .MuiTableHead-root": {
            "& .MuiTableRow-root": {
              backgroundColor: '#f3f3f3',
              "& .MuiTableCell-root": {
                padding: "8px 10px",
                fontWeight: "600",
                fontSize: "0.875rem",
               
                borderBottom: '1px solid #f3f3f3',
                backgroundColor: '#f3f3f3',
              },
              "& .MuiButtonBase-root": {
                padding: "0px",
                margin: "0px",
                fontWeight: "600",
                fontSize: "0.875rem",
                 color: "#454f59",
                whiteSpace: "nowrap",
              },
            },
          },
          "& .MuiTableBody-root": {
            "& .MuiTableRow-root": {
              "&:hover": {
                backgroundColor: "rgba(238, 242, 247, 0.45)",
              },
              "& .MuiTableCell-root": {
                padding: ".65rem .6rem",
                fontSize: "0.85rem",
                color: theme.colors.bodyText,
                borderBottom: `1px solid ${theme.colors.light}`,
              },
              "&.email-sent-row": {
                "& .MuiTableCell-root": {
                  color: "red", // Red text for rows with email-sent-row class
                  transition: "color 0.3s ease", // Smooth transition
                  // Optional: Theme-specific styles
                  // ...(theme.palette.mode === 'dark' && {
                  //   color: '#ff5555', // Lighter red for dark theme
                  // }),
                },
              },
            },
          },
          "& .MuiTableFooter-root": {
            "& .MuiTableRow-footer": {
              "& .MuiTableCell-footer": {
                padding: ".75rem .6rem",
                fontSize: "0.875rem",
                color: theme.colors.bodyText,
                "& .MuiToolbar-root": {
                  minHeight: "auto",
                  "& .MuiTablePagination-selectLabel": {
                    margin: 0,
                  },
                  "& .MuiTablePagination-displayedRows": {
                    margin: 0,
                  },
                  "& .MuiTablePagination-selectIcon": {
                    // position:'relative',
                    right: "-1rem",
                  },
                },
              },
            },
          },
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: "1rem",
          borderBottom: `1px solid ${theme.colors.themeBorder}`,
          fontSize: "1.15rem",
          fontWeight: "600",
          "& .MuiSvgIcon-root": {
            color: theme.colors.secondary,
            cursor: "pointer",
          },
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: "1rem!important",
          borderBottom: `1px solid ${theme.colors.themeBorder}`,
          fontSize: "1.15rem",
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: "1rem!important",
          gap: "0.50rem",
        },
      },
    },
    MuiTabs: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          //  backgroundColor: theme.colors.light,
          //borderBottom: `1px solid ${theme.colors.light}`,
          borderBottom: "none!important",
          padding: "0",
          minHeight: "auto",
          "&.scroll-tabs": {
            paddingLeft: "0px",
            paddingRight: "0px",
          },
          "& .MuiTabs-indicator": {
            display: "none",
          },
          "& .MuiTabs-scroller": {
            "& .MuiTabs-flexContainer": {
              gap: "0.0rem",
            },
          },
          "& .MuiTabScrollButton-root": {
            backgroundColor: "#eeeef3",
            border: "1px solid #eeeef3",
            "&.Mui-disabled": {
              opacity: 0.3,
            },
          },
        },
      },
    },
    MuiTab: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          "& .MuiTypography-root": {
            fontSize: "0.875rem",
          },
          position: "relative",
          display: "block",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          color: `#9290a8!important`,
          backgroundColor: "transparent",
          border: "none",
          zIndex: 0,
          padding: "0.55rem 1.5rem 0.55rem 1rem",
          minHeight: "auto",
          
          "&::after": {
            position: "absolute",
            top: "1px",
            right: '-12px',
            bottom: "-2px",
            left: "1px",
            zIndex: -1,
            content: '""',
            outline: `1px solid #eaeaf4`,
            borderRadius: "10px 10px 0 0",
            background: '#fafaff',
            transform: "perspective(5px) rotateX(0.93deg) translateZ(-1px)",
            transformOrigin: "0 0",
            backfaceVisibility: "hidden",
          },
          "& .MuiBox-root": {
            gap: "0.25rem",
            justifyContent: "center",
          },
          "&.Mui-selected": {
            backgroundColor: "transparent",
            fontWeight: 600,
            color: `${theme.colors.primary} !important`,
            zIndex: 1,
            "& .MuiTypography-root": {
              fontWeight: 600,
            },
            "&::after": {
              background: theme.colors.white,
              boxShadow: "none",
            },
            "& .MuiChip-root": {
            background: theme.colors.primary,
              "& .MuiChip-label": {
                color: theme.colors.white,
              },
            },
          },
          "& .MuiChip-root": {
            margin: "0px",
            backgroundColor: '#e5eaf0',
            color: '#737f8b',
            borderRadius: "10px",
            fontWeight: "600",
            minWidth:'10px',
            "& .MuiChip-label": {
              fontSize: "0.65rem",
              padding: "3px 9px",
            },
          },
        },
      },
    },

    MuiStepper: {
      styleOverrides: {
        root: {
          backgroundColor: theme.colors.lightPrimary,
          padding: "0.50rem 0.50rem",
          "& .Mui-completed": {
            "& .MuiStepLabel-iconContainer": {
              "& .MuiStepIcon-root": {
                fill: theme.colors.primary,
                color: theme.colors.white,
                "& .MuiStepIcon-text": {
                  fill: theme.colors.white,
                },
              },
            },
            "& .MuiStepLabel-labelContainer": {
              "& .MuiStepLabel-label": {
                color: theme.colors.primary,
              },
            },
          },
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        root: {
          "& .MuiStepLabel-iconContainer": {
            "& .MuiStepIcon-root": {
              fill: "rgba(255, 255, 255, 1)",
              color: theme.colors.bodyText,
              "& .MuiStepIcon-text": {
                fill: theme.colors.bodyText,
                fontSize: "0.875rem",
                fontWeight: "600",
              },
              "&.Mui-active": {
                fill: "rgb(119 60 211 / 57%)",
              },
            },
          },
          "& .MuiStepLabel-labelContainer": {
            "& .MuiStepLabel-label": {
              color: theme.colors.bodyText,
              fontSize: "0.875rem",
              textTransform: "capitalize",
              marginTop: "0.33rem",
              fontWeight: "500",
              // 🔴 Color for active step label
              "&.Mui-active": {
                color: "rgb(119, 60, 211)",
              },
            },
          },
        },
      },
    },
    MuiStepConnector: {
      styleOverrides: {
        root: {
          "& .MuiStepConnector-line": {
            backgroundColor: "rgba(255, 255, 255, 0.50)!important",
          },
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          //border: `1px solid ${theme.colors.primary}`,
          border: `1px solid #c9cccf`,
          "&::before": {
            display: "none",
          },
          "& .MuiAccordion-heading": {
            "& .MuiAccordionSummary-root": {
              backgroundColor: theme.colors.lightPrimary,
              padding: "0.3rem 1rem",
              "& .MuiAccordionSummary-content": {
                color: theme.colors.primary,
              },
              "& .MuiSvgIcon-root": {
                color: theme.colors.primary,
              },
              "&.Mui-expanded": {
                minHeight: "auto",
              },
            },
            "& .MuiAccordionSummary-content": {
              margin: "0px",
            },
          },
          "& .MuiAccordionDetails-root": {
            padding: "1rem",
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        body1: {
          fontSize: '0.875rem',
        },
      },
    },

  };
}
